import type { Product } from '@grafikr/shopify-typescript/type/liquid/Product';

export default (root: Document | Element = document) => {
  const dataElement = root.querySelector('[data-js-data]');

  if (!dataElement) {
    return null;
  }

  return JSON.parse(dataElement.innerHTML) as Product;
};
